document.addEventListener("DOMContentLoaded", function() {
    function showIcons() {
        const icons = document.querySelectorAll('.site-nav.site-nav--icons, .site-nav__icons');

        icons.forEach(icon => {
            icon.style.setProperty('display', 'flex', 'important');
            icon.style.setProperty('visibility', 'visible', 'important');
            icon.style.setProperty('opacity', '1', 'important');
        });
    }

    showIcons();
    window.addEventListener("resize", showIcons);
});